import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseViewElement } from '../base-view-element';
import { PropertySet } from '../../../core/model/helper-models/property-set.model';
import { Property } from '../../../core/model/helper-models/property.model';

@Component({
  selector: 'app-prtlrbt-x',
  templateUrl: './prtlrbt-x.component.html',
    styleUrls: ['./prtlrbt-x.component.scss',
        './../card.scss'],
    standalone: false
})
export class PrtlrbtXComponent  extends BaseViewElement implements OnChanges
{

    @Input() Maintenance: PropertySet;

    Distance: Property<any>;
    Positioning: Property<any>;

    constructor()
    {
        super('prtlrbt-x');
    }


    onResize(result: any)
    {
        this.childResizeEvent.emit();
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        if (this.Maintenance == null) return;
        this.Distance = this.Maintenance.properties.get('X_AXIS_DISTANCE');
        this.Positioning = this.Maintenance.properties.get('X_AXIS_SWITCHING_CYCLE');
    }

}
